import React from 'react';
import './Contact.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const contacts = [
  {
    icon: <FaPhone />,
    label: 'Phone',
    value: '+1 (905) 537-7979',
    href: 'tel:+19055377979',
  },
  {
    icon: <FaEnvelope />,
    label: 'Email',
    value: 'holdenrogers79@hotmail.com',
    href: 'mailto:holdenrogers79@hotmail.com',
  },
  {
    icon: <FaMapMarkerAlt />,
    label: 'Location',
    value: 'Hamilton, Ontario',
    href: null,
  },
];

const Contact = () => (
  <div className="contact-page">
    <div className="contact-page__hero">
      <h1>Get in Touch</h1>
      <p>Ready to take your game to the next level? Reach out and we'll set you up.</p>
    </div>

    <div className="contact-page__body">
      <div className="contact-cards">
        {contacts.map(({ icon, label, value, href }) => (
          <div className="contact-card" key={label}>
            <div className="contact-card__icon">{icon}</div>
            <span className="contact-card__label">{label}</span>
            {href ? (
              <a className="contact-card__value" href={href}>{value}</a>
            ) : (
              <span className="contact-card__value">{value}</span>
            )}
          </div>
        ))}
      </div>

      <div className="contact-note">
        <p>
          We typically respond within <strong>24 hours</strong>. Sessions fill up fast — don't wait.
        </p>
      </div>
    </div>
  </div>
);

export default Contact;
